<template>
	<div id="app" class="app" :class="{ 'disabled': loading }">
		<web-header/>
		<router-view/>
		<web-footer/>
		<div class="loading-layer">
			<div class="w-100 h-100 d-flex align-items-center justify-content-center">
				<font-awesome-icon icon="circle-notch" spin size="4x" class="text-muted" />
			</div>
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueAnimate from 'vue-animate-scroll'
import VueScrollTo from 'vue-scrollto'

import WebHeader from '@/components/WebHeader.vue'
import WebFooter from '@/components/WebFooter.vue'

import './styles/master.scss'

const moment = require('moment')
require('moment/locale/it')

Vue.use(BootstrapVue)
Vue.use(VueAnimate)
Vue.use(VueScrollTo)
Vue.use(require('vue-moment'), {moment})

Vue.directive('i18n', function (el, binding, vnode) {
	if (binding.arg == vnode.context.$root.lang.id) {
		if (Object.keys(binding.modifiers).length) {
			el.setAttribute(Object.keys(binding.modifiers)[0], binding.value);
			return;
		}
		el.innerHTML = binding.value;
	}
});

export default {
	components: {
		WebHeader,
		WebFooter
	},
	computed: {
		loading: function() {

			//console.log(this.$route.name);

			return this.$root.loading && 'UserJoin' != this.$route.name;
		}
	}
};
</script>

<style lang="scss">

.app {
	transition: opacity 0.2s ease-in;
	.loading-layer {
		position:fixed;
		left:0;
		top:0;
		right:0;
		bottom:0;
		background:rgba(255,255,255,.5);
		z-index:1200;
		backdrop-filter:blur(4px);
		opacity:0;
		transition:.2s all;
		pointer-events: none;
	}
	&.disabled {
		/*opacity: 0.98;*/
		pointer-events: none;
		.loading-layer {
			opacity:1;
		}
	}
}


</style>